import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus, gql } from '@apollo/client'
import { Paper, Typography } from '@material-ui/core'
import { CartChangeFiltersContext } from '../../../../context/CartChangeFiltersContext'
import ChartColumn from '../../../../components/charts/ChartColumn'
import ChartColumnSkeleton from '../../../../components/skeletons/ChartColumnSkeleton'
import { ChartColumnThemes } from '../../../../components/charts/types/ChartColumn'
import { formatNumber } from '../../../../utils/Helpers'
// import { PHARMACY_RECEIVED_USERS } from '../../../../queries/cartChange'

const PHARMACY_RECEIVED_USERS = gql`
  query GetPharmacyReceivedUsers($filters: EventCartChangeFilter) {
    eventCartChangeAggs(
      filters: $filters,
      index: "eventos-fapp-cart-change-accepted*",
      size: 0,
      aggs: {
        pharmacies: {
          terms: {
            field: "items.new_pharmacy_id",
            size: 5
          }
        }
      }
    ) {
      aggregations
    }
  }
`

interface Bucket {
  key: string,
  doc_count: number
}
const PharmaciesReceivedUsers = (): JSX.Element => {
  const { filters } = useContext(CartChangeFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    PHARMACY_RECEIVED_USERS, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <ChartColumnSkeleton />
  if (loading || !data) return <ChartColumnSkeleton />
  if (error) return <p>Error :(</p>
  if (!data.eventCartChangeAggs.aggregations.pharmacies) return <p>No data found</p>

  const { buckets } = data.eventCartChangeAggs.aggregations.pharmacies
  const categories: Array<string> = []
  const seriesData: Array<number> = []
  buckets.map((bucket: Bucket) => {
    categories.push(bucket.key)
    return seriesData.push(bucket.doc_count)
  })

  const options = {
    chart: {
      id: 'pharmacies-more-received-users'
    },
    xaxis: {
      categories
    },
    grid: {
      show: false
    },
    plotOptions: {
      bar: {
        dataLabels: {
          position: 'top'
        }
      }
    },
    dataLabels: {
      offsetY: -20,
      formatter: (val: number) => {
        return formatNumber(val, 0, true)
      },
      style: {
        colors: ['#304758']
      }
    },
    yaxis: {
      labels: {
        formatter: (value: number) => {
          return formatNumber(value, 0, true)
        }
      }
    }
  }
  const series = [{
    name: 'Usuários',
    data: seriesData
  }]

  if (!data) return <></>

  return <Paper elevation={2}>
    <Typography
      paragraph
      style={{ paddingLeft: '20px', paddingTop: '20px' }}
    >
      TOP 5 farmácias que receberam mais usuários
    </Typography>
    <ChartColumn options={options} series={series} theme={ChartColumnThemes.green} height={280} />
  </Paper>
}

export default PharmaciesReceivedUsers
